import { Box } from '@mui/material'
import { useCurrentSong } from '../../hooks/contexts/currentSongContext'
import { Image } from './Image/Image'
import logo from '../f_500x500_white_bg.png'
import Text from './Text'
import { LanguageCode, SONG_TYPES } from '../../utils/types'
import { formatString } from '../../utils/formatter'
import { formatKeytone, getSongTitle } from '../../utils/songHelpes'
import { useCurrentUser } from '../../hooks/contexts/currentUserContext'

const NowPlaying = () => {
    const currentSong = useCurrentSong()
    const currentUser = useCurrentUser()
    const lang: LanguageCode = currentUser?.customer?.userSettings?.language ?? 'sv'
    const isKeytone = currentSong?.type === SONG_TYPES.KEY
    if (!currentSong) return null

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ height: 'clamp(80px, 18vh, 180px)', overflow: 'hidden', borderRadius: 1 }}>
                <Image src={currentSong.img || logo} description={currentSong.title} sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
            </Box>
            <Box sx={{ py: 'clamp(8px, 1.2vh, 16px)' }}>
                <Text bold displayedLines={1} overflow="hidden">
                    {isKeytone ? formatKeytone(currentSong.key, lang) : getSongTitle(currentSong, lang)}
                </Text>
            </Box>
        </Box>
    )
}

export default NowPlaying
